@if (mobile()) {
  <ui-bottom-sheet
    #sheet
    [headerTemplate]="headerTemplate()"
  >
    <ng-container *ngTemplateOutlet="content" />
  </ui-bottom-sheet>
} @else {
  <ui-popover #popover>
    <ng-container *ngTemplateOutlet="content" />
  </ui-popover>
}

<ng-template #content>
  <div
    class="flex flex-col min-w-56 gap-1 p-1"
    role="menu"
    tabindex="-1"
    (keydown)="onListKeydown($event)"
  >
    <ng-content />
  </div>
</ng-template>
